//-================ IMPORTS FOR GENERAL COMPONENT ================-\\
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';


//-================ IMPORTS FOR SERVICES ================-\\
import { LIBRARYCCPService } from 'src/app/Services/Libraries/General-CCP/library-ccp.service';


//-================ IMPORTS FOR DEPENDENCIES ================-\\
import { saveAs } from "file-saver"
import moment from 'moment';
import Swal from 'sweetalert2';


//-================ IMPORTS FOR INTERFACES ================-\\
import { Last_Version_Approved } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Last_Version_Approved.interface';
import { Headers_CCP } from 'src/app/Interfaces/Libraries/Library-CCP-Int/Headers-CCP.interface';
import { Download_Log_CCP } from 'src/app/Constants/Backlog/CCP/Download_Log';
import { Response_CCP } from 'src/app/Interfaces/Interfaces-Global/Response.interface';


@Component({
    selector: 'app-latest-approved-ccp',
    templateUrl: './latest-approved-ccp.component.html',
    styleUrls: ['./latest-approved-ccp.component.scss', '../../../../Styles/GlobalStyles.css', '../../../../Styles/LatestApprovedGlobal.css'],
    standalone: false
})
export class LatestApprovedCCPComponent implements OnInit {


  //+================== VARIABLES FOR HEADERS LAST APPROVED ==================+\\
  public HeadersLA: Headers_CCP[] = [
    { ID: 1, Name: 'Versión', Position: 1, Visible: true, Key_Header: 'VER' },
    { ID: 1, Name: 'Nombre de CCP', Position: 1, Visible: true, Key_Header: 'NAH' },
    { ID: 1, Name: 'Año de modelo', Position: 1, Visible: true, Key_Header: 'MOY' },
    { ID: 1, Name: 'Código', Position: 1, Visible: true, Key_Header: 'COD' },
    { ID: 1, Name: 'Folio', Position: 1, Visible: true, Key_Header: 'INV' },
    { ID: 1, Name: 'Fecha de carga', Position: 1, Visible: true, Key_Header: 'DAC' },
    { ID: 1, Name: 'Fecha de aprobación  ', Position: 1, Visible: true, Key_Header: 'DAA' },
    { ID: 1, Name: 'Aprobador', Position: 1, Visible: true, Key_Header: 'APP' },
    { ID: 1, Name: 'Revisor', Position: 1, Visible: true, Key_Header: 'REV' },
  ];

  //+================== VARIABLES FOR COLOR SWETALERT ==================+\\
  private ColorConfirm: string = '#20a8e1';
  private ColorsCancel: string = '#fc6161';


  //+================== VARIABLES FOR KEYS SNAPSHOTS ==================+\\
  private ID_CCP: number = 0;

  //+================== VARIABLES FOR CCP DOCUMENT ==================+\\
  public LastApprovedCCP: Last_Version_Approved = {
    ID: 0,
    Extension: '',
    Name: '',
    Key_Word: '',
    Revision_No: '',
    Model_Year: 0,
    Code: '',
    Invoice_4M: '',
    Status: 0,
    ID_Folder: 0,
    ID_Involved_User_Reviewer: 0,
    ID_Involved_User_Approver: 0,
    Reviewer_Name: '',
    Approver_Name: '',
    Date_Created: null,
    Date_Expiration: null,
    ID_Contributor: 0,
    Contributor_Name: '',
    ID_Previous_Version: 0,
    ID_Next_Version: 0,
    Status_System: 0,
    Date_End: null,
    Directory: false,
  }

  constructor(private Service_CCP: LIBRARYCCPService, private activatedRouter: ActivatedRoute) {
    this.ID_CCP = Number(this.activatedRouter.snapshot.params['idC']);
  }

  ngOnInit(): void {
    this.Load_Component_LA();
  }

  private async Load_Component_LA(): Promise<void> {

    const Loader = document.getElementById('Loader') as HTMLDivElement;
    Loader.classList.add('active');

    try {

      const ResLastApproved: any = await firstValueFrom(this.Service_CCP.Get_Last_Version_Approved({ ID_CCP: this.ID_CCP }));

      if (ResLastApproved.success) {

        if (!ResLastApproved.operation.Exist_VA) {

          Swal.fire({
            title: 'Sin versión aprobada',
            text: '¡La HOE no tiene versiones anteriores aprobadas!',
            icon: 'warning',
            confirmButtonColor: this.ColorConfirm
          }).then((result) => {
            window.close();
          })

        } else {

          this.LastApprovedCCP = ResLastApproved.operation.CCP;

        }
      }


      Loader.classList.remove('active');

    } catch (e) {

      Swal.fire({
        title: 'Error',
        text: '¡Error al cargar la ultima versión aprobada, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
      Loader.classList.remove('active');
    }

  }

  //&===================== FUNCTIONS FOR GENERAL LAST VERSION APPROVED =====================&\\

  //-================ FUNCTION FOR DATE FORMAT ================-\\
  public DateFormat(Date_Created: Date | null): string {
    return moment(Date_Created).utc().format('DD/MM/YYYY hh:mm:ss a')
  }


  //-================ FUNCTION DOWNLOAD VERSION ================-\\
  public async DownloadFile(): Promise<void> {

    const Btn_Download = document.getElementById(`Btn-Download`) as HTMLDivElement;
    const Progress_Bar_Task = document.getElementById(`Progress-Bar-Task`) as HTMLSpanElement;

    try {

      const ResGetURL_LVA: Response_CCP = await firstValueFrom(this.Service_CCP.Get_URL_Last_Version_DownloadCCP({ ID_CCP: this.LastApprovedCCP.ID, Type_D: Download_Log_CCP.D_LAST_VERSIONA }));

      const URL = ResGetURL_LVA.operation.URL_CCP;

      if (ResGetURL_LVA.success) {


        this.Service_CCP.DownloadCCP(URL).subscribe((event: any) => {

          const Text_Btn = document.getElementById(`Text-Btn`) as HTMLElement;
          const Icon_Btn = document.getElementById(`Icon-Btn`) as HTMLElement;

          Btn_Download.classList.add('active');

          if (event.status === 404) {
            Btn_Download.classList.remove('active');
            Progress_Bar_Task.style.width = '0%';
            Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-xmark');
            Text_Btn.innerHTML = 'Error';

            const Toast = Swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
              }
            })

            Toast.fire({
              icon: 'error',
              title: '¡Error al descargar la HOE, informa a tu supervisor!'
            })

          }

          if (event['loaded'] && event['total']) {

            let Discharge_Rate: number = Math.round(event['loaded']) / event['total'] * 100;

            Progress_Bar_Task.style.width = Discharge_Rate + '%';

          }
          if (event['body']) {

            Progress_Bar_Task.style.width = '0%';
            Btn_Download.classList.remove('active');

            if (event.status === 200) {

              Icon_Btn.classList.replace('fa-cloud-arrow-down', 'fa-check-double');
              Text_Btn.innerHTML = 'Completada';

              const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener('mouseenter', Swal.stopTimer)
                  toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
              })

              Toast.fire({
                icon: 'success',
                title: 'HOE descargada!'
              })

              saveAs(event['body'], this.LastApprovedCCP.Name);

            }

          }
        })


      }

    } catch (e) {
      Swal.fire({
        title: 'Error',
        text: '¡Error al descargar la HOE, informa a tu supervisor!',
        icon: 'warning',
        confirmButtonColor: this.ColorConfirm
      })
    }

  }

  //&===================== END FUNCTIONS FOR GENERAL LAST VERSION APPROVED =====================&\\


}
